import { CircularProgress } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { Container } from './Loader.styled';

export default function Loader() {
    const game = useGame();

    if (!game.loading && game.ready) {
        return null;
    }

    return (
        <Container>
            <CircularProgress color="inherit" size={20} />
        </Container>
    );
}
